import React from 'react';
import { authService } from '../../utils/auth-service';
import Header from '../header';

import ThemeSelector from '../../themes/theme-selector';

const theme = ThemeSelector.theme();

const authCheck = () => {
  return authService.loggedIn();
};

const MobileLock = () => {
  const href = theme.mobileRedirectLink || 'www.dyzio.co';
  const title = theme.title || 'dyzio';
  return (
    <div className="page">
      {authCheck()
        ? <Header />
        : <div className="logo-container">
            <a href="/"><img src={theme.darkLogo.src} alt={theme.darkLogo.alt} /></a>
          </div>}
      <div className={authCheck() ? 'mobile-lock' : 'mobile-lock no-header'}>
        <div className="mobile-highlight">
          <img src="/icons/computer.svg" alt="computer" />
        </div>
        <div className="spacer" />
        <h3>
          Ciao! {title} can only be accessed on large screen devices at the moment, so make sure you log in using a computer or tablet.
        </h3>
        <div className="spacer" />
        <p className="small"><a href={href}>Back to {href}</a></p>
      </div>
    </div>
  );
};

export default MobileLock;



/** WEBPACK FOOTER **
 ** ./src/components/mobile-lock/index.js
 **/